import script from "./Layout3.vue?vue&type=script&lang=ts&setup=true"
export * from "./Layout3.vue?vue&type=script&lang=ts&setup=true"

import "./Layout3.vue?vue&type=style&index=0&id=2a57a6a7&scoped=true&lang=css"

import exportComponent from "/data/jenkins/workspace/jet/cbt/production/deploy-cbt/exam/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a57a6a7"]])

export default __exports__